import { useCallback } from 'react'

import { useTribeClient } from '../../useTribeClient.js'

export const useCanContactMembers = () => {
  const { client } = useTribeClient()

  const canContactMembers = useCallback(
    async (memberIds: string[]) => {
      const contactability = await client.messaging.checkMembersContactability({
        memberIds,
      })
      return contactability
    },
    [client],
  )

  return {
    canContactMembers,
  }
}
